export default __webpack_public_path__ + "static/media/pandora.7d1da700.svg";